export default "__VITE_PUBLIC_ASSET__52c604ca__"